import React, { useEffect } from "react";
import loadingSymbol from "../assets/loading_icon.gif";

function Loading({ loadingMessage }) {

  return (
    <div className="loading-window">
      <img src={loadingSymbol} alt="loading" />
      <p>{loadingMessage}</p>
    </div>
  );
}

export default Loading;
